<script setup>
import { reactive } from 'vue';
import PatientInfo from '@/appointment/AppointmentInfoPatientWidget.vue'
import RuleHelpVue from './RuleHelp.vue';
import { helpObject } from '@/libraries/QuestionHelpObjects';

const props = defineProps(['newApt', 'patient', 'showQuestions', 'showLengthQuestion']);
const emits = defineEmits(['updateAptInfo', 'openPatient']);

const state = reactive({
  patient: props.patient,
})


function openPatient() {
  debugger
  emits('openPatient', state.patient);
}

/**
 * Toggles the value of state.helpObject. When not null, this will show the help modal. 
 * @param {string} rule whichever rule the action wants to display
 */
 function setHelpObject(rule) {
  switch (rule) {
    case 'travel':
      state.helpObject = helpObject.travel;
      return;
    case 'firstPersonSeen':
      state.helpObject = helpObject.firstPersonSeen;
      return;
    case 'specialVisit':
      state.helpObject = helpObject.specialVisit;
      return;
    case 'sacrifice':
      state.helpObject = helpObject.sacrificeOfHours;
      return;
  }
}
</script>
<template>


<RuleHelpVue v-if="state.helpObject" :helpObject="state.helpObject" @close="state.helpObject = null"/>



  <div class="content-box">
    <PatientInfo :patient="patient" @openPatient="openPatient" />

    <div class="form-item">
      <label for="appointmentDate">Appointment Date</label>
      <input v-model="newApt.date" type="date" name="appointmentDate"> <br>
    </div>
    <div class="form-item">
      <label for="patientType">Patient Type</label>
      <select v-model="newApt.aptType" name="patientType">
        <option value="regular">Out-Patient</option>
        <option value="inpatient">In-patient</option>
        <option value="unscheduled">Unscheduled</option>
        <option value="emergency">Emergency Department</option>
      </select>
    </div>
    <div class="form-item">
      <label for="diagnosis">Diagnosis</label>
      <select name="diagnosis" v-model="newApt.diagnosis">
        <option value='Breast Cancer'>Breast Cancer</option>
        <option value='Central Nervous System Cancer'>Central Nervous System Cancer</option>
        <option value='Endocrine Cancer'>Endocrine Cancer</option>
        <option value='Gastrointestinal Cancer'>Gastrointestinal Cancer</option>
        <option value='Genitourinary Cancer'>Genitourinary Cancer</option>
        <option value='Gynecologic Cancer'>Gynecologic Cancer</option>
        <option value='Head & Neck Cancer'>Head & Neck Cancer</option>
        <option value='Hematologic Cancer'>Hematologic Cancer</option>
        <option value='Lung Cancer'>Lung Cancer</option>
        <option value='Ocular / Eye Cancer'>Ocular / Eye Cancer</option>
        <option value='Sarcoma'>Sarcoma</option>
        <option value='Skin Cancer'>Skin Cancer</option>
        <option value='Metastatic'>Metastatic</option>
        <option value="Other">Other</option>
      </select>
    </div>

    <div class="form-item">
      <label for="appointmentEndTime">Appointment End Time</label>
      <input type="time" v-model="newApt.time">
    </div>
<br>
    <div class="subtitle"><i class="fa fa-wand-magic-sparkles"></i> Recommended Questions</div>

    <div class="form-item" v-if="newApt.time">
        <label for="specialVisit">Was the visit a special visit? <i @click="setHelpObject('specialVisit')"
            class="fa fa-circle-info"></i></label>
        <select value="No" v-model="newApt.specialVisit">
          <option value="No">No</option>
          <option value="emergency">Emergency Department</option>
          <option value="outpatient">Hospital Out-Patient Department</option>
          <option value="inpatient">Hospital In-Patient</option>
          <option value="longTermCare">Long Term Care Institution</option>
          <option value="pallativeCare">Pallative Care</option>
          <option value="patientsHome">Patients Home (not long term care)</option>
          <option value="physiciansOffice">Physicians Office</option>
          <option value="geriatric">Geriatric</option>
          <option value="other">Other (non-professional setting not listed)</option>

        </select>
      </div>

    <!-- FOR TESTING DATES THIS IS ENABLED -->
    <div v-if="showQuestions.length > 0 || true">

      <div v-if="showQuestions.indexOf('newDiagnosis') > -1" class="form-item">
        <label for="newDiagnosis">New Diagnosis? (from previous consult)</label>
        <input type="checkbox" v-model="newApt.newDiagnosis">
      </div>

      <div v-if="showLengthQuestion" class="form-item">
        <label for="length">How many minutes was your appointment?</label>
        <input type="number" v-model="newApt.length">
      </div>

      <div v-if="showQuestions.indexOf('seenAnotherDoctor') > -1" class="form-item">
        <label for="newDiagnosis">Seen Another Doctor?</label>
        <input type="checkbox" v-model="newApt.seenAnotherDoctor">
      </div>

      

      <div class="form-item" v-if="newApt.specialVisit != 'No'">
        <label for="firstVisit">Was this the first person you saw at the location? <i
            @click="setHelpObject('firstPersonSeen')" class="fa fa-circle-info"></i></label>
        <input type="checkbox" v-model="newApt.firstPersonSeen" @click="updateSpecialVisitCodes">
      </div>

      <div class="form-item" v-if="newApt.specialVisit != 'No'">
        <label>Did you travel to see this patient? <i @click="setHelpObject('travel')"
            class="fa fa-circle-info"></i></label>
        <input type="checkbox" v-model="newApt.performedTravel" @click="updateSpecialVisitCodes">
      </div>

      <div class="form-item" v-if="newApt.specialVisit != 'No'">
        <label>Did you see this patient at the sacrifice of office hours? <i @click="setHelpObject('sacrifice')"
            class="fa fa-circle-info"></i></label>
        <input type="checkbox" v-model="newApt.sacrificeOfOfficeHours" @click="updateSpecialVisitCodes">
      </div>

      <!-- THIS COULD BE FACTORED INTO REQUIRED QUESTIONS -->
      <div class="form-item" v-if="newApt.specialVisit == 'patientsHome'">
        <label>Was this an elective home visit</label>
        <input type="checkbox" v-model="newApt.electiveHomeVisit">
      </div>

    </div>

  </div>
</template>
<style lang="scss" scoped>
div.container {
  max-width: 1000px;
  display: flex;
  margin: auto;

  .left {
    flex: 1;
    margin-right: 10px;
  }

  .right {
    flex: 1;
    margin-left: 10px;
  }
}
div.subtitle {
  color: #673ab7;
  text-transform: uppercase;
}
span.label {
    display: inline-block;
    vertical-align: top;
    padding-top: 4px;
    color: #673ab7;
    text-transform: uppercase;
}
</style>